import React, { useState } from "react";
import Search from "./Search";
import { dbURL } from "./global";
import { Link, Routes, Route } from "react-router-dom";

function Header(props) {
  const [searchWindow, setSearchWindow] = useState(false);
  const [trashActive, setTrashActive] = useState(false);
  const logo = <img src="../images/hotel_bold.svg" alt="Agit" />;
  const trashIcon = <img src="../images/trash.svg" alt="Current"></img>;
  const activeDocsIcon = (
    <img src="../images/document-search.svg" alt="Current"></img>
  );
  const adminAccess = props.userType === "admin" ? true : false;
  const semiAdminAccess = props.userType === "semiadmin" ? true : false;

  function switchView() {
    const views = ["table", "boxes"];
    let viewNumber = views.indexOf(props.view);
    let nextViewNumber = viewNumber + 1 === views.length ? 0 : viewNumber + 1;
    props.setView(views[nextViewNumber]);
  }

  async function logOut() {
    const logOut = await fetch(dbURL + "logout.php", {
      credentials: "include",
    });
    const result = await logOut.text();
    console.log(result, props);
    props.setLoggedIn(false);
  }

  return (
    <header>
      <div className="logo">{logo}</div>
      <Routes>
        <Route
          path="search"
          element={
            <Search
              searchValue={props.searchValue}
              setSearchValue={props.setSearchValue}
              handleSearchValue={props.handleSearchValue}
              trigger={setSearchWindow}
            />
          }
        />
      </Routes>

      <nav
        className="menu"
        style={{ display: searchWindow ? "none" : "block" }}
      >
        <Link to="modal">
          <button
            className="new"
            onClick={() => {
              props.emptyModalData.modalType = "new";
              props.setModalData(props.emptyModalData);
            }}
          >
            <div>
              <img src="../images/add.svg" alt="Dodaj" />
            </div>
            <div className="buttonText">Dodaj wpis</div>
          </button>
        </Link>
        <Link to="search">
          <button className="search">
            <div>
              <img src="../images/search.svg" alt="Wyszukiwanie" />
            </div>
            <div className="buttonText">Filtruj</div>
          </button>
        </Link>

        {adminAccess || semiAdminAccess ? (
          <button
            className={"trash" + (trashActive ? " active" : "")}
            onClick={() => {
              props.showDeleted();
              props.setTableTypeText((prev) => !prev);
              setTrashActive((prev) => !prev);
            }}
          >
            <div>{trashActive ? activeDocsIcon : trashIcon}</div>
            <div className="buttonText">
              {trashActive ? "Do aktywnych" : "Do usuniętych"}
            </div>
          </button>
        ) : (
          ""
        )}

        <button className="view" onClick={switchView}>
          <div>
            <img src="../images/eyeglasses.svg" alt="Widok" />
          </div>
          <div className="buttonText">Zmień widok</div>
        </button>
        <Link to="/">
          <button className="logout" onClick={logOut}>
            <div>
              <img src="../images/door-lock.svg" alt="Wyloguj" />
            </div>
            <div className="buttonText">Wyloguj</div>
          </button>
        </Link>
      </nav>
    </header>
  );
}

export default Header;
